import { getCDNUrl } from '../utils/cdnUtils';
import ISDBLogoFooter from '../assets/ISDBLogoFooter.svg';
const Footer = () => {
    return (
        <footer>
            <div className="footer-content">
				<div className="container-fluid container-inner-pages">
					<div className="row">
						<div  className="col-lg-4 col-12 clearfix logo-section">
  
<img loading="lazy" src={getCDNUrl(ISDBLogoFooter)} alt='IsDB Logo' width="167" height="87"/>

                <p>Working to improve the lives of those we serve by promoting social and economic development in Member countries and Muslim communities worldwide, delivering impact at scale.</p>

      


<div className="social-link">
	        <a href="https://www.instagram.com/isdb_stories" title='instagram logo' className="footer-social-link" targer="_blank" target="_blank">
          <i className="icon-instagram footer-social-link-icon"></i>
         
        </a>
	        <a href="https://www.facebook.com/isdbgroup/" title='facebook logo' className="footer-social-link" targer="_blank" target="_blank">
          <i className="icon-facebook footer-social-link-icon"></i>
        
        </a>
	        <a href="https://twitter.com/isdb_group" title='X logo' className="footer-social-link" targer="_blank" target="_blank">
          <i className="icon-X footer-social-link-icon"></i>
         
        </a>
	        <a href="https://www.linkedin.com/company/islamic-development-bank/" title='linkedin logo' className="footer-social-link" targer="_blank" target="_blank">
          <i className="icon-linkedIN footer-social-link-icon"></i>
      
        </a>
	</div>

  </div>

<nav className="col-lg-5 col-12">
  </nav>




<div className="col-lg-3 col-12 clearfix">
  <div className="contact-info">
  <h4>Contact Information</h4>

<div className="name-contacts key-value">
			<div className="footer-content-info d-flex">
			<i className="icon-call-phone footer-content-info-icon : "></i>
			<span className="footer-content-info-text text-ltr"><span className="text-light-blue">+966</span>126361400</span>
		</div>
			<div className="footer-content-info d-flex">
			<i className="icon-fax footer-content-info-icon : "></i>
			<span className="footer-content-info-text text-ltr"><span className="text-light-blue">+966</span>126361400</span>
		</div>
			<div className="footer-content-info d-flex">
			<i className="icon-email footer-content-info-icon : "></i>
			<span className="footer-content-info-text text-ltr">info@isdb.org</span>
		</div>
			<div className="footer-content-info d-flex">
			<i className="icon-Location footer-content-info-icon : "></i>
			<span className="footer-content-info-text text-ltr">8111 King Khalid St. AI Nuzlah AI Yamania Dist. Unit No.1 Jeddah 22332-2444 Kingdom of Saudi Arabia</span>
		</div>
	</div>
    </div>


  </div>



					</div>
				</div>
			</div>
            <div className="footer-bottom">
				Copyright © 2025 IsDB. All Rights Reserved.
			</div>
        </footer>
    )
};

export default Footer;